import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font } from '../theme/base/mixins';
import { StyledDivComponent } from '../types';
import { Row } from './Grid';
import { Icon } from './Icon';
import {
  NavigationHeader,
  NavigationLink,
  NavigationListItem
} from './Navigation';
import { Paragraph } from './Paragraph';
import { Title } from './Title';

export const DataLayer: StyledDivComponent = styled.div`
  padding: 20px 35px;
  text-align: left;
  color: ${({ theme }: ThemeProps<Theme>) => theme.colors.black};
  width: 984px;

  ${NavigationHeader} {
    padding: 0;
  }
`;

export const DataContent: StyledDivComponent = styled.div`
  ${font()};

  ${Paragraph} {
    ${font(1.8, 2.4, '300')};
  }

  ${Title.ContentTitle} {
    ${font(1.8, 2.4, 'bold')};
  }

  ${NavigationListItem} {
    ${NavigationLink} {
      ${font(1.8, 2.1, '500')};
      color: ${({ theme }: ThemeProps<Theme>) => theme.colors.primary};
      z-index: inherit !important;

      ${Icon} {
        path {
          fill: ${(props: ThemeProps<Theme>) => props.theme.colors.primary};
        }
      }

      &:hover {
        color: ${({ theme }: ThemeProps<Theme>) => theme.colors.primaryHover};
      }
    }
  }

  ${Row} {
    display: flex !important;
  }
`;
